<template>
  <div class="title">
    <div class="border"/>
    <slot/>
  </div>
</template>
<script>
  export default {
    name: "CommonTitle"
  };
</script>
<style lang="scss" scope>
  .title {
    // margin-bottom: 12px; /* no */
    width: 100%;
    font-weight: 600;
    font-family: Microsoft YaHei;
    font-size: 14px; /* no */
    line-height: 26px; /* no */
    letter-spacing: 0;
    color: #333;
    border-bottom: 1px #adadad solid;
    // margin-top: 20px; /* no */
    padding-bottom: 20px;
    display: flex;
    position: relative;
    align-items: center;
    // justify-content: space-between;
    .border {
      width: 10px;
      height: 30px;
      background: #43a6df;
      margin-right: 10px;
    }
    span {
      color: #f00;
      font-weight: normal;
      position: absolute;
      right: 0;
    }
    b {
      font-weight: normal;
      position: absolute;
      right: 0;
    }
  }
</style>
